import Fuse from 'fuse.js'
import { reduce } from 'lodash'

class DB {
  constructor(array = [], filterKeys, optionList) {
    const options = {
      useExtendedSearch: true,
      keys: Object.values(filterKeys),
      ...optionList,
    }
    this.db = new Fuse(array, options)
    this.filterKeys = filterKeys
  }

  search(query) {
    console.log('DB query', query)
    const results = this.db.search(query)
    return results.map(result => result.item)
  }

  filter(filter, $or = null) {
    console.log('DB filter', filter)
    // 把object的每個value前面加上"="，然後最後包在array內
    // { a: '123', b: '456'  } => [{ a: '=123' }, { b: '=456' }]
    const $and = reduce(filter, (list, val, key) => {
      if (!this.filterKeys[key]) return list
      const prop = this.filterKeys[key]
      list.push({ [prop]: `=${val}` })
      return list
    }, []);

    if ($or) $and.push({ $or })
    return this.search({ $and })
  }
}

export default DB